<div *ngIf="isLoading">Loading Product List...</div>

<select *ngIf="!isLoading" (change)="optionChanged.emit(true)" [compareWith]="byId" class="form-control" name="product"
        [(ngModel)]="model.product" [required]="required">
  <option *ngFor="let singleProduct of products" [ngValue]="singleProduct">{{ singleProduct.name }}</option>
</select>
